import React, { Component } from "react";
import MessagesMainScreen from "./MessagesMain.js";
import MessagesThread from './MessagesThread'
import { createStackNavigator } from '@react-navigation/stack';
import { Container, Button, Text, Icon, Footer, FooterTab } from "native-base";
import { Styles, Layouts } from '../../utils';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';


//// NOTE: Tab nav not needed here for now
// const Tab = createBottomTabNavigator();

// function MessageTabNavigator({ navigation }) {

//   Layouts.StackNavigationHeader({navigation});

//   return (

//     <Tab.Navigator>
//       <Tab.Screen name="MessagesMainScreen" component={MessagesMainScreen} />
//     </Tab.Navigator>

//   );
// }

const screensList = [
    {
        name: "MessagesMainScreen",
        scrComp: MessagesMainScreen,
        Title: "Messages",
    },
    {
        name: "MessagesThread",
        scrComp: MessagesThread,
        Title: "Messages-Thread",
    }
]

export default function MessageScreenNavigator({ route, navigation }) {
    return(
        <Layouts.GenerateStackRoutes screensList={screensList} route={route} navigation={navigation} />
    )
}
